<script>
import formatDate from '@utils/format-date'
import { messageSuccess } from "@utils/message"
import formMixin from "@components/Form/mixins/form";
import { authComputed } from '@store/helpers'

const DEFAULT_SUBMIT_DATA = {
  invoice_type: "",
  invoice_ubn_num: "",
  invoice_ubn_buyer: "",
  invoice_carrier_type: "",
  invoice_carrier_num: "",
  invoice_lovecode: ""
};

export default {
  page() {
    return {
      title: `會員中心 | 發票資訊`,
    }
  },
  components: {
    MemberLayout: () => import("./components/Layout.Jtails"),
  },
  mixins: [formMixin],
  props: {
    value: {
      type: Object,
      default: () => {
        return { ...DEFAULT_SUBMIT_DATA }
      },
    },
    type: {
      type: String,
      default: 'add',
      validator(value) {
        return [
          'add',
          'edit',
        ].includes(value)
      },
    },
    invoiceInfo: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      errorMessage: '',
      taxTypeOption: [
        {
          text: '個人',
          value: '0',
        },
        {
          text: '公司',
          value: '1',
        },
      ],
      CarrierTypeOption: [
        {
          text: '會員載具',
          value: '2',
        },
        {
          text: '手機條碼',
          value: '0',
        },
        {
          text: '自然人憑證條碼',
          value: '1',
        },
        {
          text: '捐贈發票',
          value: '3',
        },
        {
          text: '索取紙本',
          value: '-1',
        },
      ],
    }
  },
  computed: {
    ...authComputed,
  },
  watch: {
    'FormMixSubmitData.invoice_carrier_type': {
      handler(v, ov) {
        this.FormMixSubmitData.invoice_carrier_num = '';
      }
    },
    'FormMixSubmitData.invoice_type': {
      handler(v, ov) {
        this.FormMixSubmitData.invoice_carrier_type = '';
        this.FormMixSubmitData.invoice_carrier_num = '';
        this.FormMixSubmitData.invoice_lovecode = '';
        this.FormMixSubmitData.invoice_ubn_num = '';
      }
    },
  },
  created() {
    const initFormMixSubmitData = () => {
      const {invoice_type, invoice_carrier_type, invoice_ubn_buyer, invoice_ubn_num, invoice_carrier_num, invoice_lovecode} = this.invoiceInfo

      this.FormMixSubmitData['invoice_type'] = invoice_type || DEFAULT_SUBMIT_DATA.invoice_type || '0'

      this.$nextTick(()=>{
        this.FormMixSubmitData['invoice_carrier_type'] = invoice_carrier_type || DEFAULT_SUBMIT_DATA.invoice_carrier_type
        this.$nextTick(()=>{
          this.FormMixSubmitData['invoice_ubn_num'] = invoice_ubn_num || DEFAULT_SUBMIT_DATA.invoice_ubn_num
          this.FormMixSubmitData['invoice_ubn_buyer'] = invoice_ubn_buyer || DEFAULT_SUBMIT_DATA.invoice_ubn_buyer
          this.FormMixSubmitData['invoice_carrier_num'] = invoice_carrier_num || DEFAULT_SUBMIT_DATA.invoice_carrier_num
          this.FormMixSubmitData['invoice_lovecode'] = invoice_lovecode || DEFAULT_SUBMIT_DATA.invoice_lovecode
          this.$FormMixinInitTempSubmitData();
        })
      })
    };

    initFormMixSubmitData();
  },
  methods: {
    onSubmit() {
      this.tryToStoreMember();
    },
    async tryToStoreMember() {
      const invoice_carrier_num = () => {
        const [phonecode, phonenumber] = (this.currentMember.phone || '+886-').split('-');

        return this.FormMixSubmitData.invoice_carrier_type === '2'
          ? phonenumber
          : this.FormMixSubmitData.invoice_carrier_num
      };

      await this.$store.dispatch('wordpress/storeMemberInvoice', {
        ...this.FormMixSubmitData,
        invoice_carrier_num: invoice_carrier_num()
      })

      messageSuccess('發票資訊修改成功');
    },
    formatCarrierNumPlaceholder() {
      switch (this.FormMixSubmitData.invoice_carrier_type) {
        case '0':
          return '請輸入手機條碼';
        case '1':
          return '請輸入自然人憑證條碼';
      }
    },
    formatCarrierNumRules() {
      switch (this.FormMixSubmitData.invoice_carrier_type) {
        case '0':
          return 'require|phonebarcode';
        case '1':
          return 'require|cpcbarcode';
      }
    }
  }
}
</script>
<!-- section template -->
<template>
  <MemberLayout
    :class="$style.viewMemberInfo"
    title="發票資訊"
    type="list"
  >
    <ValidationObserver v-slot="{ invalid, handleSubmit }">
      <el-form
        ref="form"
        :model="FormMixSubmitData"
        label-position="top"
        class="isStyleBase"
        :class="$style.formInfo"
        @submit.prevent.native="handleSubmit(onSubmit)"
      >
        <div class="mb-5">
            <ValidationProvider
              v-slot="{ errors }"
              rules="require"
              name="發票開立"
            >
              <el-form-item :error="errors[0]" label="發票開立" prop="invoice_type">
                <el-select
                  v-model="FormMixSubmitData.invoice_type"
                  placeholder="發票開立"
                  class="w-full"
                >
                  <el-option
                    v-for="(invoice_type, $index) in taxTypeOption"
                    :key="$index"
                    :label="invoice_type.text"
                    :value="invoice_type.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </ValidationProvider>
          
          
          <!--個人-->
          <template v-if="FormMixSubmitData.invoice_type === '0'">
            <!--載具類別-->
            <ValidationProvider
              v-slot="{ errors }"
              name="載具類別"
            >
              <el-form-item :error="errors[0]" label="載具類別" prop="invoice_carrier_type">
                <el-select
                  v-model="FormMixSubmitData.invoice_carrier_type"
                  placeholder="載具類別"
                  class="w-full"
                >
                  <el-option
                    v-for="(carrierType, $index) in CarrierTypeOption"
                    :key="$index"
                    :label="carrierType.text"
                    :value="carrierType.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </ValidationProvider>
            <ValidationProvider
              v-if="!['-1', '3'].includes(FormMixSubmitData.invoice_carrier_type)"
              v-slot="{ errors }"
              :rules="formatCarrierNumRules()"
              name="載具編號"
            >
              <el-form-item :error="errors[0]" label="載具編號" prop="invoice_carrier_num">
                <el-input
                  v-model="FormMixSubmitData.invoice_carrier_num"
                  :placeholder="formatCarrierNumPlaceholder()"
                >
                </el-input>
              </el-form-item>
            </ValidationProvider>
            <!--捐贈-->
            <template v-if="FormMixSubmitData.invoice_carrier_type === '3'">
              <ValidationProvider
                v-slot="{ errors }"
                rules="require|lovecode"
                name="捐贈碼"
              >
                <el-form-item :error="errors[0]" label="捐贈碼" prop="invoice_lovecode" class="isRequired">
                  <el-input
                    v-model="FormMixSubmitData.invoice_lovecode"
                    placeholder="請輸入捐贈碼"
                  >
                  </el-input>
                  <BaseButton
                    href="https://www.einvoice.nat.gov.tw/APCONSUMER/BTC603W/"
                    target="_blank"
                    class="isStylePrimary isTextUnderline2"
                  >
                    <span class="text-h6">查詢捐贈碼</span>
                  </BaseButton>
                </el-form-item>
              </ValidationProvider>
            </template>
          </template>

          <!--公司-->
          <template v-if="FormMixSubmitData.invoice_type === '1'">
            <!--買受人-->
            <ValidationProvider
              v-slot="{ errors }"
              rules="require"
              name="買受人"
            >
              <el-form-item :error="errors[0]" label="買受人" prop="invoice_ubn_buyer" class="isRequired">
                <el-input
                  v-model="FormMixSubmitData.invoice_ubn_buyer"
                  placeholder="請輸入買受人全名"
                >
                </el-input>
              </el-form-item>
            </ValidationProvider>
            <!--統一編號-->
            <ValidationProvider
              v-slot="{ errors }"
              rules="require|companyid"
              name="統一編號"
            >
              <el-form-item :error="errors[0]" label="統一編號" prop="invoice_ubn_num" class="isRequired">
                <el-input
                  v-model="FormMixSubmitData.invoice_ubn_num"
                  placeholder="請輸入公司統一編號"
                >
                </el-input>
              </el-form-item>
            </ValidationProvider>
          </template>
        </div>
        <div class="row pt-4">
          <div class="col-md-6">
            <BaseButton
              class="isStylePrimary isOutline3 isFull isRadius mb-3 mb-md-0"
              @click="$FormMixinOnResetSubmitData"
            >
              取消
            </BaseButton>
          </div>
          <div class="col-md-6">
            <BaseButton
              :disabled="invalid"
              :loading="$isLoading('storeMemberInvoice')"
              class="isStyleSecondary isFull isRadius"
              type="submit"
            >
              儲存修改
            </BaseButton>
          </div>
        </div>
      </el-form>
      <BasePre>FormMixSubmitData: {{ FormMixSubmitData }}</BasePre>
    </ValidationObserver>
  </MemberLayout>
</template>
<!-- section style -->
<style lang="scss" module>
.formInfo {
  :global {
    .formInfo {
      @include unstyled;
    }
  }
}
</style>
